import React from 'react'
import { Box, MenuItem } from '@mui/material'
import Select, { Icon } from '@/components/common/Select'

import { CHAIN_INFO, SUPPORTED_CHAIN } from '@/constants'
import { BtcLogo } from '@/components/common/TokenLogo'
import { Row } from '@/components/common/Rows'

interface NetworkOption {
  value: number
  label: string
  logoSrc: string
}

export const OPTIONS: NetworkOption[] = Object.values(SUPPORTED_CHAIN).map((chain) => ({
  value: chain.id,
  label: chain.abbreviation,
  logoSrc: chain.logoSrc,
}))

interface NetworkSelectProps {
  value: string
  onChange: (value: string) => void
  target: 'From' | 'To'
}

const NetworkSelect = ({ value, onChange, target }: NetworkSelectProps) => {
  return (
    <Select<string>
      value={value}
      renderIcon={(value) => {
        if (!value) return null
        if (value === '0') {
          return (
            <Row>
              {target}:&nbsp;&nbsp;
              <BtcLogo size={24} />
            </Row>
          )
        }
        return (
          <Row>
            {target}:&nbsp;&nbsp;
            <Icon src={CHAIN_INFO[value].logoSrc} alt={CHAIN_INFO[value].name} />
          </Row>
        )
      }}
      renderLabel={(value) => {
        if (!value) return null
        if (value === '0') {
          return `Bitcoin`
        }
        return `${CHAIN_INFO[value].abbreviation}`
      }}
      displayEmpty
      renderEmpty={() => {
        return `${target}: All Chains`
      }}
      onChange={(event) => {
        onChange(event.target.value)
      }}
      sx={{ height: 40 }}
    >
      <MenuItem sx={{ width: '100%', height: 40 }} value={''}>
        {`All Chains`}
      </MenuItem>

      <MenuItem sx={{ width: '100%', height: 40 }} value={'0'}>
        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
          <BtcLogo size={24} />
          Bitcoin
        </Box>
      </MenuItem>

      {OPTIONS.map((option) => (
        <MenuItem key={option.value} sx={{ width: '100%', height: 40 }} value={String(option.value)}>
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
            <Icon src={option.logoSrc} alt={option.label} />
            {option.label}
          </Box>
        </MenuItem>
      ))}
    </Select>
  )
}

export default NetworkSelect
